export default {
    edit: 'Редактирай',
    location: 'Локация + Условия',
    filter: 'Филтър',
};
